import { render, staticRenderFns } from "./recomedShopInClass.vue?vue&type=template&id=35cbb7f0&scoped=true"
import script from "./recomedShopInClass.vue?vue&type=script&lang=js"
export * from "./recomedShopInClass.vue?vue&type=script&lang=js"
import style0 from "./recomedShopInClass.vue?vue&type=style&index=0&id=35cbb7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbb7f0",
  null
  
)

export default component.exports